import axios from "axios"
import library from "../../../utils/Library"

export const getLoginAccountStatusCorpEntities = async () => {
  const TOKEN = sessionStorage.getItem("token")
  const URL =
    library.getBaseAPIUrl("login_account") +
    "/getLoginAccountStatusCorpEntities"

  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  })
}
